import { AssistanceSaleQuestionMetadata } from './assistance-sale-question-metadata';
import { QuestionSuggestedAnswer } from './questionsuggestedanswer';

export const QUESTION_TYPE = {
  TYPE_DROPDOWN: { id: 1, text: 'Dropdown' },
  TYPE_RADIO: { id: 2, text: 'Radio' },
  TYPE_TEXT: { id: 3, text: 'Text' },
  TYPE_CHECKBOX: { id: 4, text: 'Checkbox' },
  TYPE_NUMBER: { id: 5, text: 'Number' },
};

export function getQuestionTypeText(type: number): string {
  const questionType = Object.values(QUESTION_TYPE).find(
    (item) => item.id === type
  );
  return questionType ? questionType.text : '';
}

export class Question {
  id: number;
  question_text: string;
  type_: number;
  status: number;
  suggestedAnswers: QuestionSuggestedAnswer[];
  deleAnswer: QuestionSuggestedAnswer[];
  suggested_value_id: number;
  answer: string;
  validator: false;
  assistance_question_metadata?: AssistanceSaleQuestionMetadata[];
}
